var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sendInvitation",attrs:{"disabled":_vm.isDisabled,"title":_vm.title},on:{"click":_vm.changeStatus}},[_vm._v(_vm._s(_vm.status))])}
var staticRenderFns = []

export { render, staticRenderFns }